import {Fragment} from "react";
import styled from "styled-components";

import TablePaginationNav from "../../TablePaginationNav";
import LoadingSpinner from "../../layout/LoadingSpinner";
import SortIcon from "../../icons/SortIcon";
import {T, TB} from "../../texts";
import {useNavigate} from "react-router-dom";
import {TableFooter} from "../../layout/TableFooter";

const ChampionshipsTable = ({
                                getTableProps,
                                headerGroups,
                                getTableBodyProps,
                                page,
                                prepareRow,
                                pageCount,
                                previousPage,
                                canPreviousPage,
                                nextPage,
                                canNextPage,
                                pageOptions,
                                gotoPage,
                                pageIndex,
                                isLoading,
                                rows
                            }) => {
    const navigate = useNavigate();
    return (
        <>
            <TableContainer>
                <TableStyled {...getTableProps()}>
                    <thead>
                    {headerGroups.map((group, index) => (
                        <Fragment key={`headerGroupFragment-${index}`}>
                            <tr {...group.getHeaderGroupProps()}>
                                {group.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                        )}
                                    >
                                        <TB>{column.render("Header")}</TB>

                                        {column.canSort ? (
                                            <SortIcon
                                                sort={
                                                    column.isSorted
                                                        ? column.isSortedDesc
                                                            ? "desc"
                                                            : "asc"
                                                        : ""
                                                }
                                            />
                                        ) : null}
                                    </th>
                                ))}
                            </tr>
                        </Fragment>
                    ))}
                    </thead>

                    {page && page.length ? (
                        <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                            prepareRow(row);

                            return (
                                <tr {...row.getRowProps()} onClick={() => navigate(`/mesterskap/${row.original.id}`)}>
                                    {row.cells.map((cell) => (
                                        <td {...cell.getCellProps()}>
                                            <T>{cell.render("Cell")}</T>
                                        </td>
                                    ))}
                                </tr>
                            );
                        })}
                        </tbody>
                    ) : null}
                </TableStyled>
            </TableContainer>

            <TableFooter>
                {pageCount > 1 && (
                    <TablePaginationNav
                        pageCount={pageCount}
                        previousPage={previousPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        canNextPage={canNextPage}
                        pageOptions={pageOptions}
                        gotoPage={gotoPage}
                        pageIndex={pageIndex}
                    />
                )}
                <div></div>
                <div>
                    <T>Antall: {rows?.length ? rows.length : 0}</T>
                </div>
            </TableFooter>

            {isLoading ? (
                <DashboardSpinner/>
            ) : !page.length ? (
                <NothingToShow>
                    <TB>{"Ingenting å vise"}</TB>
                </NothingToShow>
            ) : null}
        </>
    );
};

export default ChampionshipsTable;

const DashboardSpinner = () => (
    <section style={{height: "30vh"}}>
        <LoadingSpinner light/>
    </section>
);

const NothingToShow = styled.section`
  min-height: 20rem;
  display: grid;
  place-items: center;

  opacity: 0;
  animation: fadeIn 500ms ease forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;

const StandardTableStyle = styled.table`
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: left;
    border-bottom: 1px solid ${(props) => props.theme.color.primary.xxlight};
    height: 2.5rem;
    padding-right: 1rem;

    .SortIcon {
      margin-left: 0.35rem;
    }
  }

  th {
    user-select: none;
    white-space: nowrap;
  }

  td {
    min-width: 5rem;
    max-width: 20rem;
    overflow-wrap: break-word;
  }

  opacity: 0;
  animation: fadeIn 500ms ease forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;

const TableContainer = styled.article`
  overflow: auto;
  margin-top: 2rem;
`;

const TableStyled = styled(StandardTableStyle)`
  min-width: 80rem;

  tr {
    cursor: pointer;

    td {
      vertical-align: top;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;

      img {
        max-width: 70px;
        max-height: 70px;
      }
    }

    td:first-child {
      text-align: left;
    }
  }
`;

